import { render, staticRenderFns } from "./majorLine.vue?vue&type=template&id=0e689128&scoped=true"
import script from "./majorLine.vue?vue&type=script&lang=js"
export * from "./majorLine.vue?vue&type=script&lang=js"
import style0 from "./majorLine.vue?vue&type=style&index=0&id=0e689128&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e689128",
  null
  
)

export default component.exports